import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment.prod';

@Injectable({
    providedIn: 'root'
})
export class HttpRequestsService {
    public api_root_url = environment.root_url + 'api/';

    constructor(private httpRequest: HttpClient) {
    }

    public sendGetRequest(routeName, token, parameter: HttpParams = new HttpParams()) {
        const request_header = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        });
        return this.httpRequest.get(this.api_root_url + routeName, {headers: request_header, params: parameter});
    }

    public sendPostRequest(routeName, body, token, parameter: HttpParams = new HttpParams()) {
        const request_header = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        });
        return this.httpRequest.post(this.api_root_url + routeName, body, {headers: request_header, params: parameter});
    }

    public sendPutRequest(routeName, body, token, parameter: HttpParams = new HttpParams()) {
        const request_header = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        });
        return this.httpRequest.put(this.api_root_url + routeName, body, {headers: request_header, params: parameter});
    }

    public sendPatchRequest(routeName, body, token, parameter: HttpParams = new HttpParams()) {
        const request_header = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        });
        return this.httpRequest.patch(this.api_root_url + routeName, body, {headers: request_header, params: parameter});
    }

    public sendDeleteRequest(routeName, token, header = null, parameter: HttpParams = new HttpParams()) {
        const request_header = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        });
        return this.httpRequest.delete(this.api_root_url + routeName, {headers: request_header, params: parameter});
    }

    public sendCustomGetRequest(full_url, token, parameter: HttpParams = new HttpParams()) {
        const request_header = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        });
        return this.httpRequest.get(full_url, {headers: request_header, params: parameter});
    }

    public sendCustomPostRequest(full_url, body, header) {
        return this.httpRequest.post(full_url, body, header);
    }

    public getRootUrl() {
        return environment.root_url;
    }

    public getApiRootUrl() {
        return this.api_root_url;
    }

    public sendGetRequestToNegarit(routeName) {
        return this.httpRequest.get(environment.root_negarit_url + routeName);
    }

    public sendPostRequestToNegarit(routeName, body, header) {
        return this.httpRequest.post(environment.root_negarit_url + routeName, body, header);
    }
}
